var React = require('react');

function SocialFacebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M27.836,0H2.164A2.164,2.164,0,0,0,0,2.164V27.836A2.164,2.164,0,0,0,2.164,30H16.025V18.4h-3.9V13.857h3.9V10.516c0-3.875,2.366-5.985,5.823-5.985a32.045,32.045,0,0,1,3.493.179V8.76H22.958c-1.881,0-2.245.894-2.245,2.206v2.892h4.5L24.624,18.4H20.713V30h7.123A2.164,2.164,0,0,0,30,27.836V2.164A2.164,2.164,0,0,0,27.836,0Zm0,0"}));
}

SocialFacebook.defaultProps = {"width":"30","height":"30","viewBox":"0 0 30 30"};

module.exports = SocialFacebook;

SocialFacebook.default = SocialFacebook;
